import React from "react"

/**
 * Standing terms / scheme info shown to the client: the low-deposit scheme,
 * best-price guarantee, booking T&Cs, financial protection and the
 * binding-contract note.
 *
 * Rendered in two places - beneath the agent card in the quote email preview
 * (send-quote-email) and at the foot of the public quote page (public-quote) -
 * so the copy lives here once. Each caller passes its own wrapper `className`
 * and styles the semantic tags (h4 / p / ul / li / a) underneath it.
 *
 * NOTE: the backend HTML email (functions-emailing/templates.ts
 * `quoteTermsBlock`) is a separate codebase and can't import this, so it carries
 * its own copy - keep the wording identical across the two.
 */
export const QUOTE_TERMS_LINKS = {
	terms: "https://www.golfholidaysdirect.com/terms-and-conditions",
	caa: "http://www.caa.co.uk",
}

export default function QuoteTerms({ className = "", balanceWeeks = 12 }) {
	return (
		<div className={className}>
			<h4>Take advantage of the Golf Holidays Direct low deposit scheme</h4>
			<ul>
				<li>
					Golf Holidays Direct will arrange accommodation and tee times with just a £100 group deposit to secure your booking. A
					non-refundable £50 deposit per person will then be required within 28 days.
				</li>
				<li>We offer flexible payment terms to suit you, payments can be made at any time until the full balance is due.</li>
				<li>Full access to manage my booking and track your group's payments.</li>
				<li>The full balance for your holiday is due {balanceWeeks} weeks before travel date.</li>
				<li>Payment can be made over the phone by debit or credit card or via bank transfer.</li>
				<li>Flight inclusive packages will require a larger deposit subject to your quote.</li>
			</ul>

			<h4>Best price guarantee</h4>
			<p>
				Golf Holidays Direct will always offer the best price within the industry, should for any reason you receive a cheaper quote
				within seven days of your booking, we will match it.
			</p>

			<h4>Booking terms and conditions</h4>
			<ul>
				<li>Prices are based on twin occupancy unless otherwise stated.</li>
				<li>All quotes are subject to availability.</li>
				<li>Golf Holidays Direct are not responsible for buggies and can only be requested subject to the venue's availability.</li>
				<li>The booking confirmation will be sent to you immediately after booking.</li>
				<li>Amendments are free and confirmed within 24-48 hours.</li>
				<li>Tee times need to be specified at the booking stage.</li>
				<li>
					Golf Holidays Direct Terms and Conditions can be viewed{" "}
					<a href={QUOTE_TERMS_LINKS.terms} target="_blank" rel="noreferrer">
						here
					</a>
					.
				</li>
			</ul>

			<h4>Financial protection</h4>
			<p>
				If your booking with Golf Holidays Direct is flight inclusive, you and your group will be covered under the ATOL scheme (Golf
				Holidays Direct ATOL licence number 11357). When you pay you will be supplied with an ATOL Certificate. Please ask for it and
				check to ensure that everything you booked (flights, hotels and other services) is listed on it. Please see our booking
				conditions for further information or for more information about financial protection and the ATOL Certificate go to:{" "}
				<a href={QUOTE_TERMS_LINKS.caa} target="_blank" rel="noreferrer">
					www.caa.co.uk
				</a>
			</p>
			<p>If your booking does not include flights, then our independently managed Trust account gives you full financial protection.</p>

			<h4>Your quote</h4>
			<p>
				This confirmation document contains the details of your quote with Golf Holidays Direct Ltd and is subject to our Terms and
				Conditions. When you make a booking, you guarantee that you have read and understand our Terms and Conditions and you have the
				authority to accept them and agree them on behalf of your group. As soon as we have received your deposit a binding contract
				will exist between you, Golf Holidays Direct Ltd and any suppliers identified.
			</p>
		</div>
	)
}
